const performanceConfig = {
    lobby: {
        defaultFrameRate: 60,
        defaultResolution: 1280,
        gamingFrameRate: 60,
        gamingResolution: 1280,
        loadingFrameRate: 60,
        loadingResolution: 1280,
    },
    jackpot: {
        frameRate: 60,
        resolution: 1280,
    },
    game: {
        defaultFrameRate: 60,
        defaultResolution: 1280,
        loadingFrameRate: 60,
        loadingResolution: 1280,
    },
};

export default performanceConfig;
